var map = {
	"./search-results-page.de-CH.json": 1180,
	"./search-results-page.de-DE.json": 1181,
	"./search-results-page.en-CA.json": 1182,
	"./search-results-page.en-GB.json": 1183,
	"./search-results-page.en-IN.json": 1184,
	"./search-results-page.en-ME.json": 1185,
	"./search-results-page.en-US.json": 1186,
	"./search-results-page.es-EM.json": 1187,
	"./search-results-page.es-ES.json": 1188,
	"./search-results-page.fr-BE.json": 1189,
	"./search-results-page.fr-CA.json": 1190,
	"./search-results-page.fr-CH.json": 1191,
	"./search-results-page.nl-BE.json": 1192,
	"./search-results-page.nl-NL.json": 1193,
	"./search-results-page.pl-PL.json": 1194,
	"./search-results-page.pt-BR.json": 1195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1179;